import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { PackagePreparerStepper } from '~/components/organisms/PackagePreparerStepper';
import { useNavigate } from '~/components/utils/Navigation';

export type IPrepareIosPackagePageProps = {
  appId: string;
  nextUrl?: string;
};

export const PrepareIosPackagePage: React.FC<IPrepareIosPackagePageProps> = (
  props,
) => {
  const { appId, nextUrl } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{t('PrepareIosPackagePage.seo.title')}</title>
      </Helmet>

      <Heading
        title={t('PrepareIosPackagePage.title')}
        subtitle={t('PrepareIosPackagePage.subtitle')}
        previousUrl={`/apps/${appId}/builds/ios`}
      />

      <PackagePreparerStepper
        appId={appId}
        onSuccess={() => navigate(nextUrl ?? `/apps/${appId}/builds/ios`)}
        platform="ios"
      />
    </>
  );
};
